module.exports = __webpack_public_path__ + "media/success.e32a92ef.mp3";